import React, { useState } from "react";
import "../supplierAndManufacturers.scss";
import BodyHeader from "./BodyHeader";
import TableBody from "./TableBody";
import { HGHighlightText } from "../../../App/App";

const CompanyItem = ({
  companyDataItem = {},
  headersList = [],
  data = [],
  searchString = '',
  sortOrder = 0,
  setSortOrder = () => { },
  getMSPAllSupplierManufacturer = () => { },
  setHeadersList = () => { },
  onItemClick = () => { },
  onAddClick = () => { },
}) => {
  const [opened, setOpened] = useState([]);

  function ToggleAccordion(e, work = true, id) {
    if (!work) return;
    var parent = e.target.closest(".point-row");
    var panel = parent.querySelector(".panel");

    setOpened((prev) => prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]);

    if (panel?.style?.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + 16 + "px";
    }
  }

  console.log('opened?.includes(companyDataItem?.ClientId)', opened?.includes(companyDataItem?.ClientId))
  return (
    <div className={`companyItem ${opened?.includes(companyDataItem?.ClientId) ? 'selectedItem' : ''} point-row`} onClick={(e) => { /*ToggleAccordion(e, true, companyDataItem?.ClientId)*/ }}
      style={{ paddingBottom: opened?.includes(companyDataItem?.ClientId) ? '16px' : '0px' }}>
      <CompanyHeader
        name={companyDataItem?.ClientName}
        search={searchString}
        icon={companyDataItem?.ClientLogo}
        itemsNumber={companyDataItem?.ClientSupplierRowData_List?.length}
        isOpen={opened?.includes(companyDataItem?.ClientId)}
        onClick={(e) => { ToggleAccordion(e, true, companyDataItem?.ClientId) }}
      />
      {
        <div className="companyDetails panel">
          {
            companyDataItem?.ClientSupplierRowData_List?.length > 0 ? <>
              <BodyHeader
                headersList={headersList}
                sortOrder={sortOrder}
                setSortOrder={setSortOrder}
                getMSPAllSupplierManufacturer={getMSPAllSupplierManufacturer}
                setHeadersList={setHeadersList}
              />
              <TableBody
                data={data}
                clientId={companyDataItem?.ClientId}
                dataToMap={companyDataItem?.ClientSupplierRowData_List}
                onItemClick={onItemClick}
                onAddClick={() => { onAddClick(companyDataItem?.ClientId ?? 0); }}
              />
            </> : <NoDataYet text={'No Supplier or Manufacturer for this company yet'} onClick={() => { onAddClick(companyDataItem?.ClientId ?? 0); }} />
          }
        </div>
      }
    </div>
  );
};

export default CompanyItem;

const CompanyHeader = ({
  name = '',
  icon = '',
  search = '',
  itemsNumber = 0,
  isOpen,
  onClick = (e) => { }
}) => (
  <div className="companyHeaderItem bg-hover-grey" onClick={(e) => { onClick(e); }}>
    <img src={"/images/chevron-down.svg"} width={11} alt="company logo" className="radius-4 mr-3" style={{ ...(isOpen ? { transform: "rotate(180deg)" } : {}) }} />
    <img src={icon ?? '/images/user-logo.svg'} width={24} height={24} alt="company logo" className="rounded-full mr-2" />
    <div>
      <span dangerouslySetInnerHTML={{ __html: HGHighlightText(name, search) }} />
      <div className="f-400 f-12 line-height-18 f-darkgrey">{`Showing ${itemsNumber} ${itemsNumber == 1 ? 'item' : 'items'}`}</div>
    </div>
  </div>
)

export const NoDataYet = ({ text = 'No data yet', onClick, style = {} }) => (
  <div className="w-100" style={style}>
    <div className="d-flex align-items-center justify-content-center w-100 f-500 f-12 f-grey py-4">{text}</div>
    {
      onClick && <div className="d-flex align-items-center justify-content-center w-100 f-500 f-12 f-grey py-4">You can add it
        <span className="pointer f-blue ml-1" onClick={onClick}>here</span>
      </div>
    }
  </div>
)